import * as React from "react";
import { Navigate, Route, Routes } from "react-router";
import { AdminPage } from "./components/AdminPage";
import { BuyDinLabel } from "./components/BuyDinLabel";
import { BuyPage } from "./components/BuyPage";
import { ComprarLicencias } from "./components/ComprarLicencias";
import { DataHubPage, DataStubPage } from "./components/DataPage";
import { Faq } from "./components/Faq";
import { InstallPage } from "./components/InstallPage";
import { MarketingHome } from "./components/MarketingHome";
import { MyLabelsPage, ViewLabelPage } from "./components/MyLabelsPage";
import { PortalDeDistribuidores } from "./components/PortalDeDistribuidores";
import { EulaPage, PrivacyPage } from "./components/PrivacyPage";
import { SignInPage } from "./components/SignInPage";
import { Tutoriales } from "./components/Tutoriales";
import { TutorialsPage } from "./components/TutorialsPage";
import { UserInfoPage } from "./components/UserInfoPage";
import { ViewDistributorsPage } from "./components/ViewDistributorsPage";
import { WebAppHome } from "./components/WebAppHome";
import { RequireAdmin, RequireAuth, consumeReturnHash } from "./shared/authGuards";

function ReturnHashRedirect() {
  React.useEffect(() => {
    const hash = consumeReturnHash();
    if (hash && hash !== "/" && window.location.hash === "#/" ) {
      window.location.hash = "#" + (hash.startsWith("/") ? hash : "/" + hash);
    }
  }, []);
  return null;
}

export function App() {
  return (
    <>
      <ReturnHashRedirect />
      <Routes>
        <Route path="/" element={<MarketingHome />} />
        <Route path="/install" element={<InstallPage />} />
        <Route path="/tutorials" element={<TutorialsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/eula" element={<EulaPage />} />
        <Route path="/viewdistributors" element={<ViewDistributorsPage />} />
        <Route path="/signin" element={<SignInPage />} />

        <Route
          path="/buy"
          element={
            <RequireAuth>
              <BuyPage />
            </RequireAuth>
          }
        />
        <Route
          path="/userinfo"
          element={
            <RequireAuth>
              <UserInfoPage />
            </RequireAuth>
          }
        />
        <Route
          path="/mylabels"
          element={
            <RequireAuth>
              <MyLabelsPage />
            </RequireAuth>
          }
        />
        <Route
          path="/mylabels/view"
          element={
            <RequireAuth>
              <ViewLabelPage />
            </RequireAuth>
          }
        />
        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminPage />
            </RequireAdmin>
          }
        />
        <Route
          path="/data"
          element={
            <RequireAdmin>
              <DataHubPage />
            </RequireAdmin>
          }
        />
        <Route
          path="/data/:section"
          element={
            <RequireAdmin>
              <DataStubPage />
            </RequireAdmin>
          }
        />

        <Route
          path="/distributorportal"
          element={
            <RequireAuth>
              <PortalDeDistribuidores />
            </RequireAuth>
          }
        />
        {/* Keep a simple account home as well */}
        <Route
          path="/account"
          element={
            <RequireAuth>
              <WebAppHome />
            </RequireAuth>
          }
        />
        <Route path="/faq" element={<Faq />} />
        <Route path="/webapp/faq" element={<Navigate to="/faq" replace />} />
        <Route
          path="/getDinLabel"
          element={
            <RequireAuth>
              <BuyDinLabel />
            </RequireAuth>
          }
        />
        <Route
          path="/webapp/getDinLabel"
          element={<Navigate to="/getDinLabel" replace />}
        />
        <Route
          path="/VerDetallesDeLicencias"
          element={<Navigate to="/distributorportal" replace />}
        />
        <Route
          path="/verDetallesDeLicencias"
          element={<Navigate to="/distributorportal" replace />}
        />
        <Route
          path="/ComprarLicencias"
          element={
            <RequireAuth>
              <ComprarLicencias />
            </RequireAuth>
          }
        />
        <Route
          path="/comprarLicencias"
          element={<Navigate to="/ComprarLicencias" replace />}
        />
        <Route path="/tutoriales" element={<Tutoriales />} />
        {/* Legacy hash route */}
        <Route path="/webapp" element={<Navigate to="/distributorportal" replace />} />
      </Routes>
    </>
  );
}
